<template>
  <div class="compliance-doc-container container-wrap">
    <easyads-head-top>
      <div class="compliance-right">
        <el-link>
          <router-link to="/">首页</router-link>
        </el-link>
        <el-divider direction="vertical"></el-divider>
        <div class="ios">
          <span class="title">iOS</span>
          <el-link 
            href="https://github.com/bayescom/EasyAds-iOS"
            target="_blank"
            style="margin-right:10px"
          >
            Github
          </el-link>
          <el-link 
            href="https://gitee.com/bayescom/EasyAds-iOS"
            target="_blank"
          >
            Gitee
          </el-link>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="andriod">
          <span class="title">Andriod</span>
          <el-link 
            href="https://github.com/bayescom/EasyAds-Android"
            target="_blank"
            style="margin-right:10px"
          >
            Github
          </el-link>
          <el-link 
            href="https://gitee.com/bayescom/EasyAds-Android"
            target="_blank"
          >
            Gitee
          </el-link>
        </div>
        <el-divider direction="vertical"></el-divider>
      </div>
    </easyads-head-top>
    <div class="content">
      <div class="main-container markdown-container">
        <div v-html="html" class="main"></div>
      </div>
    </div>
  </div>
</template>

<script>
import showdown from 'showdown'
import readMe  from '../../assets/easyads_cr.md';
export default {
  data () {
    return {
      md: readMe,
      html: ''
    }
  },

  mounted () {
    let converter = new showdown.Converter()
    let text = this.md.toString()
    this.html = converter.makeHtml(text)
  },

  components: {
    showdown
  }
}
</script>

<style lang="scss" scoped>
.compliance-right {
  height: 80px;
  display: inline-block;
  line-height: 80px;
  
  & > div {
    display: inline-block;
  }

  .title {
    font-weight: 700;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/compliance/index.vue